import React from "react";
import {
  Box,
  Heading,
  Flex,
  Text,
  Button,
  VStack,
  Image,
  SimpleGrid,
} from "@chakra-ui/react";
import arrow from "./Images/Button-Arrow.svg";
import DashboardImage from "./Images/Dashboard-Image.svg";
import TrackingToolsImage from "./Images/Tracking-tools-image.svg";
import FeedbackReportsImage from "./Images/Feedback-reports-image.svg";
import TailoredSolutionsImage from "./Images/Tailored-solutions-image.svg";
import AccessibilityImage from "./Images/accessibility-image.svg";
import ProgramTimeImage from "./Images/program-time-image.svg";
import FullSubjectProgramImage from "./Images/full-subject-program-image.svg";


import { Link as RouterLink } from "react-router-dom";


const features = [
  {
    title: "Program Time",
    description:
      "Our structured 3 to 6-month program is designed for efficiency, ensuring students make significant academic progress in a relatively short period.",  
    image: ProgramTimeImage,
  }, 
  {
    title: "Accessibility ",
    description: " Online and accessible from anywhere Himmats breaks down geographical barriers by providing an online platform accessible from anywhere. Himmats held the courage to prove that education is no longer limited to a physical space. ", 
    image: AccessibilityImage,
  }, 
  {
    title: "Full Subject Program",
    description: " Full subject program: we cover a mix of subjects tailored to every child's target major specifications for the University", 
    image: FullSubjectProgramImage, 
  }, 
  {
    title: "Dashboard",
    description:
      "Track your progress with a powerful, student-friendly dashboard that visualizes your performance, highlights your strengths, and identifies areas for improvement.",
    image: DashboardImage,
  },
  {
    title: "Tracking Tools",
    description:
      "Stay in control of your learning journey with smart tracking tools that monitor your activity, suggest focus areas, and keep you motivated along the way.",
    image: TrackingToolsImage,
  },
  {
    title: "Feedback Reports",
    description:
      "Receive instant, AI-powered feedback on your past paper answers with detailed reports that help you understand mistakes and improve your exam technique.",
    image: FeedbackReportsImage,
  },
  {
    title: "Tailored Solutions",
    description:
      "Get personalized, step-by-step solutions designed for your specific need. Including Test Mode simulations with time limits, locked screens, and secure exam environments.",
    image: TailoredSolutionsImage,
  },
];


const Program = () => {
  return (
    <Box
      id="program"
      w="100%"
      px={{ base: "20px", md: "85px" }}
      mt="60px"
    >
      <Flex
        flexDirection={{ base: "column", lg: "row" }}
        gap={{ base: "40px", lg: "60px" }}
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <VStack alignItems="flex-start" w={{ base: "100%", lg: "50%" }} gap="14px">
          <Heading
            color="#161616"
            fontSize={{ base: "24px", md: "32px" }}
            fontWeight="550"
            w={{ base: "100%", lg: "850px" }}
          >
            Program Benefits
          </Heading>
          <Text
            w={{ base: "100%", md: "578px" }}
            color="#343634"
            fontSize={{ base: "12px", md: "18px" }}
            fontWeight="400"
          >
At Himmats, we recognize that each subject is a crucial building block for a student's overall success. Our mission is to provide a transformative educational experience that ensures every student succeeds.           </Text>
          <Button
            as={RouterLink}
            to="/courses"          
            target="_blank"
            rel="noopener noreferrer"
            borderRadius="24px"
            border="2.5px solid #E8E8E8"
            px={6}
            py={3}
            variant="outline"
          >
            <Flex align="center" gap={2}>
              <Text fontSize="14px" fontWeight="400">
                Access Courses
              </Text>
              <Image src={arrow} alt="arrow" boxSize="20px" />
            </Flex>
          </Button>
        </VStack>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacingX="40px" spacingY="40px" w="100%">
          {features.map((feature, index) => (
            <Flex
              key={index}
              direction="column"
              gap="14px"
              align="flex-start"
              w="100%"
              borderRadius="14px"
              border="1px solid #D7D7D7"
              p="18px 17px"
              transition="background 0.3s ease-in-out"
              _hover={{
                bg: "#EBF2F7",
              }}
            >
              <Flex direction="row" gap="14px" align="center">
                <Image src={feature.image} alt={feature.title} />
                <Heading
                  color="#161616"
                  fontSize={{ base: "14px", md: "18px" }}
                  fontWeight="500"
                >
                  {feature.title}
                </Heading>
              </Flex>
              <Text
                color="#343634"
                fontSize={{ base: "12px", md: "16px" }}
                fontWeight="400"
              >
                {feature.description}
              </Text>
            </Flex>
          ))}
        </SimpleGrid>
      </Flex>
    </Box>
  );
};

export default Program;


